"use client";

import MoonIcon from "@/components/Icons/MoonIcon";
import SunIcon from "@/components/Icons/SunIcon";
import { useCommonTranslations } from "@/providers/I18n/hooks/useCommonTranslations";
import { useTheme } from "@/providers/Theme/ThemeProvider";

export default function ThemeToggle() {
	const commonT = useCommonTranslations();
	const { themeName, toggleTheme } = useTheme();

	const isDark = themeName === "dark";

	return (
		<button
			type="button"
			onClick={toggleTheme}
			aria-label={
				isDark
					? commonT("theme.switchToLight")
					: commonT("theme.switchToDark")
			}
			className="flex size-9 items-center justify-center rounded-full text-current transition-colors hover:bg-white/10"
		>
			{isDark ? <SunIcon size={20} /> : <MoonIcon size={20} />}
		</button>
	);
}
